import React, { useEffect } from "react";
import { FiX } from "react-icons/fi";

import { cn, toAbsolute } from "./groupPlanningUtils";

const FALLBACK = "/img/no-image.jpg";

export default function DojoPhotoModal({ open, dojo, onClose }) {
  useEffect(() => {
    if (!open) return undefined;

    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  if (!open || !dojo) return null;

  return (
    <div
      className="fixed inset-0 z-[80] flex items-center justify-center bg-slate-950/80 p-4 backdrop-blur-sm"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="relative w-full max-w-5xl"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          className={cn(
            "absolute -right-3 -top-3 z-10",
            "grid h-11 w-11 place-items-center rounded-full",
            "border border-white/20 bg-white/90 text-slate-700 shadow-xl",
            "transition hover:text-primary dark:bg-slate-900 dark:text-slate-200"
          )}
          aria-label="Fermer"
        >
          <FiX className="text-xl" />
        </button>

        <img
          src={toAbsolute(dojo.dojo_photoURL) || FALLBACK}
          alt={dojo.dojo_nom}
          className="max-h-[82vh] w-full rounded-[2rem] border border-white/20 object-contain shadow-2xl"
          onError={(event) => {
            event.currentTarget.src = FALLBACK;
          }}
        />

        <div className="mt-4 text-center text-sm font-bold text-white/90">
          {dojo.dojo_nom}
        </div>
      </div>
    </div>
  );
}